<app-widget-card
        icon="assets/icons/ic_device.svg"
        [title]="'Video Call' | i18next"
        [showAreaPlaceholder]="isBusy"
        minHeight="500px">
    <div class="video-container">

        <video #videoElem autoplay playsinline (loadeddata)="onLoad()" class="main-call-video" [ngClass]="{'pip' : onHold || forwarded }"></video>

        <video #secondVideoElem autoplay playsinline (loadeddata)="onLoad()" class="second-call-video" [ngClass]="{'visible': onHold || forwarded }"></video>

        <div class="hold-overlay" [ngClass]="{'pip' : onHold || forwarded }">
            <div class="hold-icon" [class.hold-icon--disabled]="forwarded" (click)="!forwarded && resume()">
                <svg-icon src="assets/icons/ic_pause.svg"></svg-icon>
            </div>
            <div class="hold-text">{{"Call.OnHold" | i18next}}</div>
        </div>

        <div class="bridging-overlay" *ngIf="bridging">
            <div class="bridging-spinner"></div>
            <div class="bridging-text">{{"Call.Bridging" | i18next}}</div>
        </div>

        <div class="autoplay-blocked-overlay" *ngIf="autoplayBlocked" (click)="resumeAudio()">
            <div class="autoplay-blocked-icon">
                <svg-icon src="assets/icons/ic_sound_off.svg"></svg-icon>
            </div>
            <div class="autoplay-blocked-text">{{ 'Call.TapToEnableAudio' | i18next }}</div>
        </div>

        <div class="video-not-streaming rtc-video-placeholder-bg" *ngIf="(sessionId || calling)" [@curtainOpen]="shouldShowVideo ? 'hide' : 'show'">
            <div class="camera-off-icon" *ngIf="!calling">
                <svg-icon src="assets/icons/ic_camera_off.svg"></svg-icon>
            </div>
            <div class="calling-overlay" *ngIf="calling">
                <div class="calling-icon">
                    <svg-icon src="assets/icons/ic_phone_call.svg"></svg-icon>
                </div>
                <div class="calling-text">{{ "Call.Calling" | i18next }} {{ remoteEntityName }}</div>
            </div>
        </div>

        <div class="video-overlay-text" *ngIf="!calling">
            <span>{{ remoteEntityName }}</span>
        </div>


        <div class="video-placeholder" *ngIf="!sessionId && !calling && !onHold && !forwarded && !bridging">
            <img [src]="placeholderUrl ?? 'assets/images/background.jpeg'" alt="Video placeholder"/>
            <div class="calling-overlay" *ngIf="calling">
                <div class="calling-icon">
                    <svg-icon src="assets/icons/ic_device.svg"></svg-icon>
                </div>
            </div>
        </div>
    </div>
    <div class="video-actions">
        <div class="actions-group">
            <dx-button
                    type="success"
                    class="talk-button"
                    [icon]="'assets/icons/ic_phone_call.svg'"
                    (onClick)="startDeviceTalkSession()"
                    [disabled]="sessionId == null || speaking || onHold || bridging || remoteEntity?.kind == CallEntityKind.Unit"
            ></dx-button>
            <dx-button
                    type="danger"
                    class="end-call-button"
                    [icon]="'assets/icons/ic_phone_call.svg'"
                    (onClick)="onCloseButtonClick()"
                    [disabled]="!hasActiveCall || onHold || bridging"
            ></dx-button>
            <dx-button
                    *ngIf="entityKind === CallEntityKind.PBX"
                    [type]="'default'"
                    class="forward-button"
                    [icon]="'assets/icons/ic_arrow_forward.svg'"
                    (onClick)="hold()"
                    [disabled]="isForwardDisabled || bridging"
            ></dx-button>
            <dx-button
                    *ngIf="entityKind === CallEntityKind.PBX && isBridgeEnabled"
                    [type]="'default'"
                    class="bridge-button"
                    [icon]="'assets/icons/ic_bridge.svg'"
                    (onClick)="bridge()"
                    [disabled]="bridging"
            ></dx-button>
            <div class="device-outputs" *ngIf="sessionId != null && (this.remoteEntityOutputs || []).length > 0">
                <div class="outputs-list">
                    <div *ngFor="let output of (remoteEntityOutputs || [])" class="output-item">
                        <dx-button
                                [text]="output.name || 'Output'"
                                [icon]="output | outputIcon"
                                type="default"
                                [disabled]="false"
                                (onClick)="onOutputClick(output)"
                        ></dx-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="actions-group">
            <dx-button
                    type="default"
                    [icon]="isMicMuted ? 'assets/icons/ic_mic_off.svg' : 'assets/icons/ic_mode.svg'"
                    (onClick)="toggleMic()"
                    [disabled]="!sessionId || bridging || isOutgoingToNonDoorstation || (remoteEntity?.kind != CallEntityKind.Unit && !speaking)"
            ></dx-button>
            <dx-button
                    *ngIf="isCameraAvailable"
                    type="default"
                    [icon]="isCameraOn ? 'assets/icons/ic_camera_on.svg' : 'assets/icons/ic_camera_off.svg'"
                    (onClick)="toggleCamera()"
                    [disabled]="!sessionId || bridging || (remoteEntity?.kind != CallEntityKind.Unit && !speaking)"
            ></dx-button>
            <dx-button
                    type="default"
                    [icon]="isAudioMuted ? 'assets/icons/ic_sound_off.svg' : 'assets/icons/ic_sound_on.svg'"
                    (onClick)="toggleAudio()"
                    [disabled]="!sessionId || bridging || isOutgoingToNonDoorstation"
            ></dx-button>
            <dx-button
                    type="default"
                    icon="assets/icons/ic_fullscreen.svg"
                    (onClick)="toggleFullscreen()"
                    [disabled]="!sessionId || bridging || isOutgoingToNonDoorstation"
            >
            </dx-button>
        </div>
    </div>
</app-widget-card>
